module.exports = __webpack_public_path__ + "img/nav-dynamic_issues.9fa3e36d.svg";